import React, { Component } from "react"
import ReactTable from "react-table"
import "react-table/react-table.css"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import request from "../../utils/request"
import DatePicker from "react-datepicker"
import "./revenue.css"

const PROVINCE_LIST = [
  'กรุงเทพมหานคร', 'สมุทรปราการ', 'นนทบุรี', 'ปทุมธานี', 'นครปฐม',
  'สมุทรสาคร', 'นครนายก', 'พระนครศรีอยุธยา', 'ฉะเชิงเทรา',

  'กระบี่', 'กาญจนบุรี', 'กาฬสินธุ์', 'กำแพงเพชร', 'ขอนแก่น',
  'จันทบุรี', 'ชลบุรี', 'ชัยนาท', 'ชัยภูมิ', 'ชุมพร', 'เชียงราย',
  'เชียงใหม่', 'ตรัง', 'ตราด', 'ตาก', 'นครพนม',
  'นครราชสีมา', 'นครศรีธรรมราช', 'นครสวรรค์', 'นราธิวาส', 'น่าน',
  'บึงกาฬ', 'บุรีรัมย์', 'ประจวบคีรีขันธ์', 'ปราจีนบุรี', 'ปัตตานี',
  'พะเยา', 'พังงา', 'พัทลุง', 'พิจิตร', 'พิษณุโลก',
  'เพชรบุรี', 'เพชรบูรณ์', 'แพร่', 'ภูเก็ต', 'มหาสารคาม', 'มุกดาหาร',
  'แม่ฮ่องสอน', 'ยโสธร', 'ยะลา', 'ร้อยเอ็ด', 'ระนอง', 'ระยอง', 'ราชบุรี',
  'ลพบุรี', 'ลำปาง', 'ลำพูน', 'เลย', 'ศรีสะเกษ', 'สกลนคร', 'สงขลา',
  'สตูล', 'สมุทรสงคราม', 'สระแก้ว', 'สระบุรี',
  'สิงห์บุรี', 'สุโขทัย', 'สุพรรณบุรี', 'สุราษฎร์ธานี', 'สุรินทร์', 'หนองคาย',
  'หนองบัวลำภู', 'อ่างทอง', 'อุดรธานี', 'อุทัยธานี', 'อุตรดิตถ์', 'อุบลราชธานี',
  'อำนาจเจริญ'
];

const formatNumber = (num) => {
  return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
}

const formatDateToString = (date) => {
  return date ? date.toISOString().split("T")[0] : null
}

const getDefaultStartDate = () => {
  const start = new Date()
  start.setDate(1)
  return start.toISOString().split("T")[0]
}

const getDefaultEndDate = () => {
  return new Date().toISOString().split("T")[0]
}

const downloadCSV = (csvContent, filename) => {
  const BOM = "\uFEFF"
  const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" })
  const link = document.createElement("a")

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute("href", url)
    link.setAttribute("download", filename)
    link.style.visibility = "hidden"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
}

class Revenue extends Component {
  state = {
    data: [],
    start_date: null,
    end_date: null,
    provinces: [],
    provincesList: PROVINCE_LIST,
    show_details: false,
    isLoading: false,
  }

  updateTimer = null

  async componentDidMount() {
    await this.fetchData()
  }

  componentWillUnmount() {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer)
    }
  }

  async fetchData() {
    const { location, history } = this.props
    const params = new URLSearchParams(location.search)

    const start_date = params.get("start_date") || getDefaultStartDate()
    const end_date = params.get("end_date") || getDefaultEndDate()
    const provincesArray = params.get("provinces")?.split(",").filter(Boolean) || []

    this.setState({
      start_date: new Date(start_date),
      end_date: new Date(end_date),
      provinces: provincesArray,
      isLoading: true
    })

    await this.fetchRevenueData(start_date, end_date, provincesArray)

    this.updateURLParams(start_date, end_date, provincesArray, params, history, location)
  }

  fetchRevenueData = async (start_date, end_date, provinces) => {
    const queryParams = new URLSearchParams({
      start_date,
      end_date,
      provinces: provinces.join(","),
      show_details: this.state.show_details,
    })

    try {
      const response = await request.get(`/booking/revenue/province?${queryParams}`)

      if (response?.data) {
        console.log("revenue by province", response.data)
        this.setState({
          data: response.data.revenueByProvince || [],
          isLoading: false
        })
      }
    } catch (error) {
      console.error("Error fetching revenue data:", error)
      this.setState({ isLoading: false })
    }
  }

  updateURLParams = (start_date, end_date, provinces, params, history, location) => {
    params.set('start_date', start_date)
    params.set('end_date', end_date)

    if (provinces.length > 0) {
      params.set('provinces', provinces.join(","))
    } else {
      params.delete('provinces')
    }

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    })
  }

  handleChangeStartDate = (date) => {
    if (date) {
      this.setState({ start_date: date }, this.debouncedUpdate)
    }
  }

  handleChangeEndDate = (date) => {
    if (date) {
      this.setState({ end_date: date }, this.debouncedUpdate)
    }
  }

  handleProvinceChange = (province) => {
    this.setState(prevState => {
      const newProvinces = prevState.provinces.includes(province)
        ? prevState.provinces.filter(p => p !== province)
        : [...prevState.provinces, province]

      return { provinces: newProvinces }
    }, this.debouncedUpdate)
  }

  handleClearAll = () => {
    this.setState({ provinces: [] }, this.debouncedUpdate)
  }

  debouncedUpdate = () => {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer)
    }

    this.updateTimer = setTimeout(() => {
      this.updateURL()
    }, 300)
  }

  updateURL = () => {
    const { location, history } = this.props
    const { start_date, end_date, provinces } = this.state

    const start_date_str = formatDateToString(start_date)
    const end_date_str = formatDateToString(end_date)

    if (!start_date_str || !end_date_str) return

    const params = new URLSearchParams(location.search)

    params.set('start_date', start_date_str)
    params.set('end_date', end_date_str)

    if (provinces.length > 0) {
      params.set('provinces', provinces.join(","))
    } else {
      params.delete('provinces')
    }

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    })

    this.setState({ isLoading: true })
    this.fetchRevenueData(start_date_str, end_date_str, provinces)
  }

  handleExport = () => {
    const { data, start_date, end_date } = this.state

    if (data.length === 0) {
      alert("No data to export")
      return
    }

    const startDateStr = formatDateToString(start_date) || "unknown"
    const endDateStr = formatDateToString(end_date) || "unknown"
    const filename = `revenue_by_province_${startDateStr}_to_${endDateStr}.csv`

    const headers = ["Province", "Total Revenue"]
    const csvRows = data.map(item => [
      item.province,
      item.totalRevenue.toFixed(2)
    ])

    const csvContent = [
      headers.join(","),
      ...csvRows.map(row => row.join(","))
    ].join("\n")

    downloadCSV(csvContent, filename)
  }

  getColumns = () => [
    {
      Header: () => <div>จังหวัด</div>,
      accessor: "province",
      Cell: ({ original }) => <div>{original.province}</div>,
      width: 200,
    },
    {
      Header: () => <div>Revenue</div>,
      accessor: "totalRevenue",
      Cell: ({ original }) => <div>{formatNumber(original.totalRevenue)}</div>,
    },
  ]

  render() {
    const { start_date, end_date, provinces, provincesList, data, isLoading } = this.state

    return (
      <div style={{ maxWidth: "100dvw" }}>
        <div className="col-md-12" style={{ paddingBottom: "10px", maxWidth: "90dvw" }}>
          <div className="row">
            <div className="col-md-3" style={{ padding: "0px" }}>
              <div className="col-md-12">
                <label style={{ fontSize: "16px", fontWeight: "500" }}>Start Date</label>
              </div>
              <div className="col-md-12" style={{ zIndex: 9 }}>
                <DatePicker
                  className="Rectangle-Datepicker-Arrpove"
                  selected={start_date}
                  onChange={this.handleChangeStartDate}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom"
                  popperModifiers={{
                    flip: { behavior: ["bottom"] },
                    preventOverflow: { enabled: false },
                    hide: { enabled: false },
                  }}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="col-md-12">
                <label style={{ fontSize: "16px", fontWeight: "500" }}>End Date</label>
              </div>
              <div className="col-md-12" style={{ zIndex: 9 }}>
                <DatePicker
                  className="Rectangle-Datepicker-Arrpove"
                  selected={end_date}
                  onChange={this.handleChangeEndDate}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom"
                  popperModifiers={{
                    flip: { behavior: ["bottom"] },
                    preventOverflow: { enabled: false },
                    hide: { enabled: false },
                  }}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="col-md-12">
                <label style={{ fontSize: "16px", fontWeight: "500", visibility: "hidden" }}>
                  Action
                </label>
              </div>
              <div className="col-md-12">
                <button
                  onClick={this.handleExport}
                  className="btn btn-primary"
                  style={{ padding: "8px 20px" }}
                >
                  Export
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12" style={{ paddingBottom: "20px", marginTop: "10px", maxWidth: "90dvw" }}>
          <div className="row">
            <div className="col-md-12">
              <div style={{ marginBottom: "10px" }}>
                <label style={{ fontSize: "16px", fontWeight: "500", marginBottom: "10px", marginRight: "15px" }}>
                  Province ({provinces.length})
                </label>
                <button
                  onClick={this.handleClearAll}
                  style={{ padding: "5px 15px" }}
                  className="btn btn-sm btn-secondary"
                  disabled={provinces.length === 0}
                >
                  Clear
                </button>
              </div>
              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #ddd",
                  padding: "10px",
                  borderRadius: "4px"
                }}
              >
                <div className="row">
                  {provincesList.map((province) => (
                    <div key={province} className="col-md-2" style={{ marginBottom: "5px" }}>
                      <label style={{ cursor: "pointer", fontWeight: "normal" }}>
                        <input
                          type="checkbox"
                          checked={provinces.includes(province)}
                          onChange={() => this.handleProvinceChange(province)}
                          style={{ marginRight: "8px" }}
                        />
                        {province}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Data Table Section */}
        <div className="mpu" style={{ maxHeight: "500px", overflowY: "auto", maxWidth: "90dvw" }}>
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
          ) : (
            <ReactTable
              data={data}
              columns={this.getColumns()}
              pageSize={25}
              showPagination={false}
              className="-striped -highlight"
            />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => ({})
const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Revenue))